<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Associations
              </div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
                v-if="
                  currentUserData &&
                    ['Admin', 'Sport Manager'].includes(currentUserData.role)
                "
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                :loading="dataLoading"
                @click="filterDialog = true"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="filter"
                    :flat="true"
                    :externalFilter="externalFilter"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template
                      slot="body-cell-association_name"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        {{ data.props.row.association_name }}
                        <q-img
                          v-if="data.props.row.capUrl"
                          :src="data.props.row.capUrl"
                          width="40px"
                          contain
                          class="q-ml-sm float-right"
                        >
                        </q-img>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          :loading="removingAssociationID == data.props.row.id"
                          @click="
                            openRemoveAssociationDialog(data.props.row.id)
                          "
                          round
                          flat
                          color="negative"
                        >
                          <q-icon name="mdi-trash-can-outline"></q-icon>
                          <q-tooltip>Remove Association</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="90vw">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Association
            </div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <associationForm
              ref="newForm"
              @close="newDialog = false"
              @loadingStateChanged="state => (createLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="90vw">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Association</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="test"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <associationForm
              ref="editForm"
              :id="viewFormData.id"
              @close="test"
              @loadingStateChanged="state => (saveLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                v-if="
                  ($refs.editForm && $refs.editForm.addMember == false) ||
                    !$refs.editForm
                "
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="removeAssociationDialog" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <div class="row text-center">
            <div class="col-12">
              <q-icon name="mdi-alert-outline" color="warning" size="xl" />
              <br />
            </div>
            <div class="col-12">
              <span>Are you sure you want to delete this Association</span>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancel"
            color="primary"
            @click="
              removeAssociationDialog = false;
              removingAssociationID = null;
            "
          />
          <q-btn
            flat
            label="Delete"
            color="negative"
            @click="removeAssociation"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="filterDialog" persistent max-width="600px">
      <q-card v-if="filterDialog" tile style="width: 600px; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Filter</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="filterDialog = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <div class="row q-pa-md">
            <div class="col-12 q-py-sm">
              <q-select
                label="Region Filter"
                :options="associationRegions"
                v-model="filter.region"
                clearable
                v-bind="siteCFG.fields.general"
              >
              </q-select>
            </div>
            <div class="col-12 q-py-sm">
              <q-select
                label="Area Filter"
                :options="associationAreas"
                v-model="filter.area"
                clearable
                v-bind="siteCFG.fields.general"
              >
              </q-select>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import associationForm from "@/components/associations/associationForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    associationForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",

      gridData: "associations/list",
      dataLoading: "associations/listLoading",
      associationRegions: "associations/regions",
      associationAreas: "associations/areas"
    })
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "association_name",
        label: "Association",
        align: "left",
        field: "association_name",
        style:
          "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

        sortable: true
      },
      {
        name: "association_abbr",
        label: "Abbr",
        align: "left",
        field: "association_abbr",
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

        sortable: true
      },
      {
        name: "email",
        label: "Contact Email",
        align: "left",
        field: "email",
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "city",
        label: "City",
        align: "left",
        field: "city",
        style:
          "min-width: 100px;max-width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "region",
        label: "Region",
        align: "left",
        field: "region",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "area",
        label: "Area",
        align: "left",
        field: "area",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },

      {
        name: "created_at",
        label: "Created At",
        align: "left",
        field: "created_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      },
      {
        name: "updated_at",
        label: "Updated At",
        align: "left",
        field: "updated_at",
        format: val =>
          val != null
            ? moment
                .utc(val)
                .local()
                .format("DD-MMM, YYYY h:mma")
            : "",
        sortable: true
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: null,
    saveLoading: false,
    viewDetailsDialog: false,

    removeAssociationDialog: false,
    removingAssociationID: null,

    // Filter
    filter: {
      search: "",
      region: null,
      area: null
    },
    filterDialog: false
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
    this.handleRoute();
    this.$store.dispatch("associations/loadMembers");
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}`);
    },
    loadData() {
      this.$store.dispatch("associations/loadAll");
    },
    handleRoute() {
      if (this.$route.params.id) {
        this.viewFormData = { id: this.$route.params.id };
        this.$nextTick(() => {
          this.viewDetailsDialog = true;
        });
      } else {
        this.viewDetailsDialog = false;
      }
    },
    test() {
      this.$router.push("/associations");
    },
    openRemoveAssociationDialog(id) {
      this.removingAssociationID = id;
      this.removeAssociationDialog = true;
    },
    removeAssociation() {
      this.removeAssociationDialog = false;
      this.$store
        .dispatch("associations/delete", {
          id: this.removingAssociationID
        })
        .then(result => {
          this.removingAssociationID = null;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },

    externalFilter(rows, terms, cols) {
      return rows.filter(row => {
        let passed = 0;

        // Text Search
        if (this.filter.search != "" && this.filter.search) {
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            passed +=
              val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;

            if (passed == 1) {
              i = cols.length;
            }
          }
        } else {
          passed += 1;
        }

        // Region Filter
        if (!this.filter.region || this.filter.region == row.region) {
          passed += 1;
        }

        // Area Filter
        if (!this.filter.area || this.filter.area == row.area) {
          passed += 1;
        }

        if (passed == 3) {
          return true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
